import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import EventSeatSharpIcon from '@material-ui/icons/EventSeatSharp';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: 'rgb(93, 173, 226)',
    textTransform: 'capitalize',
  },
  seatData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nameSeat: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#D7DBDD',
  },
  name: {
    textAlign: 'start',
    textTransform: 'capitalize',
    width: 120,
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
}));
const seatFramer = {
  hover: { scale: 1.2 },
};

function Seat({ handleSeatClick, seat, sameBoxSeat, pageFrom }) {
  const classes = useStyles();
  const [selected, setSelected] = useState(false);

  // const isFull = "Y"; //should come from backend -- true if seat is already reserved
  const isFull = seat.isSeatAssign;

  const choseColor = () => {
    if (sameBoxSeat) {
      return 'lightpink';
    } else if (isFull === 'Y') {
      return '#A93226';
    } else if (selected) {
      return '#229954';
    }
    return '#AED6F1';
  };

  const chosePointer = () => {
    const cursorVar = sameBoxSeat
      ? 'pointer'
      : isFull === 'N'
      ? 'pointer'
      : 'not-allowed';
    return cursorVar;
  };

  useEffect(() => {
    if (sameBoxSeat) {
      handleSeatClick(seat, selected);
      return;
    } else if (isFull === 'Y') {
      return;
    } else {
      handleSeatClick(seat, selected);
      return;
    }
  }, [selected]);

  return (
    <div
      className={classes.nameSeat}
      onClick={() => setSelected((prevState) => !prevState)}
    >
      <motion.div
        style={{
          width: 30,
          height: 30,
          marginLeft: 10,
          marginRight: 10,
          marginTop: 4,
          marginBottom: 10,
          color: '#000000',
          cursor: chosePointer(),
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
        variants={seatFramer}
        whileHover={sameBoxSeat ? 'hover' : isFull === 'N' && 'hover'}
      >
        <Tooltip
          classes={{ tooltip: classes.customTooltip }}
          id='tooltip-top'
          title={(seat.firstName || '(empty)') + ' ' + (seat.lastName || '')}
          placement='top'
        >
          <div className={classes.seatData}>
            <EventSeatSharpIcon style={{ fill: choseColor() }} />
            <Typography
              variant='caption'
              gutterBottom
              style={{ color: choseColor() }}
              noWrap
            >
              {seat.seatName}
            </Typography>
          </div>
        </Tooltip>
      </motion.div>
      {pageFrom === 'layout' ? (
        <Typography variant='caption' noWrap className={classes.name}>
          {(seat.firstName || '(empty)') + ' ' + (seat.lastName || '')}
        </Typography>
      ) : null}
    </div>
  );
}

export default Seat;
